// Use these values to align with stylevalues as defined in settings.breakpoints.scss

// 'xs':     320px,
// 'sm':     640px,
// 'md':     768px,
// 'md-lg':  900px,
// 'lg':     1248px,
// 'xl':     1440px

const Breakpoints = {
	xs: () => 320,
	sm: () => 640,
	md: () => 768,
	mdlg: () => 900,
	lg: () => 1248,
	xl: () => 1440
};

export default Breakpoints;
